import React from "react";
import { Leaf, Recycle, Sprout, Wind } from "lucide-react";

const items = [
  { icon: <Leaf size={18} />, title: "Biodegradable Materials", desc: "Food-grade paperboard from sustainably managed forests." },
  { icon: <Recycle size={18} />, title: "Recyclable Products", desc: "All products designed for paper-stream recycling." },
  { icon: <Sprout size={18} />, title: "Reduced Plastic Use", desc: "Replacing single-use plastics with paper alternatives." },
  { icon: <Wind size={18} />, title: "Energy Efficient Plant", desc: "Optimized lines and lighting cutting energy consumption." },
];

export const Sustainability = () => {
  return (
    <section
      id="sustainability"
      data-testid="sustainability-section"
      className="relative py-24 md:py-32"
      style={{ background: "linear-gradient(180deg, #ECFDF5 0%, #F7FEFB 100%)" }}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-6">
            <div className="font-mono-vc text-xs uppercase tracking-[0.25em] text-emerald-700 font-bold">
              Sustainability Commitment
            </div>
            <h2 className="mt-4 font-display text-4xl md:text-5xl font-extrabold text-neutral-900 leading-[1.05]">
              Building a <span className="text-emerald-700">Sustainable Future</span> for Generations to Come.
            </h2>
            <p className="mt-5 text-neutral-700 max-w-xl leading-relaxed">
              Every paper cup, napkin and container we produce begins with a simple promise: leave less behind.
              From forest to factory to filling station, our products are designed to give back to the planet.
            </p>

            <div className="mt-9 grid sm:grid-cols-2 gap-4">
              {items.map((it) => (
                <div key={it.title} className="rounded-2xl bg-white/70 backdrop-blur border border-emerald-100 p-5">
                  <div className="w-9 h-9 rounded-lg bg-emerald-600 text-white flex items-center justify-center mb-3">
                    {it.icon}
                  </div>
                  <div className="font-display font-bold text-neutral-900">{it.title}</div>
                  <p className="text-sm text-neutral-600 mt-1.5">{it.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-6 relative">
            <div className="rounded-3xl overflow-hidden border border-emerald-100 aspect-[4/5] relative">
              <img
                src="https://images.unsplash.com/photo-1769610712905-efbfdb66a4d6?crop=entropy&cs=srgb&fm=jpg&q=85"
                alt="Sustainable packaging"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-emerald-900/40 to-transparent" />
              <div className="absolute left-5 bottom-5 right-5 text-white">
                <div className="font-mono-vc text-[10px] uppercase tracking-[0.2em] opacity-80">Our Forest Commitment</div>
                <div className="font-display text-2xl font-bold mt-1">2 trees planted per tonne of paper used</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
